var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomContainer', {
    staticClass: "introVideosWrapper introVideosModal"
  }, [_c('CustomModal', {
    attrs: {
      "customClass": "generic-modals v--modal new-modal",
      "name": "introVideos",
      "width": "100%",
      "fullHeight": true,
      "height": _vm.fullScreen || _vm.isMobile ? '100%' : 'auto',
      "maxWidth": _vm.fullScreen ? Infinity : 500
    },
    on: {
      "beforeClose": _vm.onCloseModal
    }
  }, [_c('CustomContainer', {
    staticClass: "new-modal-wrapper customs-tools",
    attrs: {
      "elementType": "section"
    }
  }, [_c('ModalHeader', {
    attrs: {
      "includeClose": _vm.type === 'customizer',
      "headerImg": true,
      "modalTitle": _vm.title
    },
    on: {
      "closeEvent": _vm.closeAction
    }
  }), _c('CustomContainer', {
    staticClass: "new-modal-main-views-wrapper",
    attrs: {
      "elementType": "section"
    }
  }, [_vm.steps || _vm.steps.length > 0 ? _c('IntroVideosMolecule', {
    attrs: {
      "assetsPath": _vm.assets,
      "onNext": _vm.onNext,
      "onSlideChange": _vm.onSlideChange,
      "steps": _vm.steps
    }
  }) : _vm._e()], 1), _c('CustomContainer', {
    staticClass: "new-modal-button-nav"
  }, [_c('CustomContainer', {
    staticClass: "new-modal-button-nav-container"
  }, [_c('CustomButton', {
    attrs: {
      "customClass": "new-modal-button-nav-container-cta expanded primary",
      "keyTranslation": "ugcIntroVideosModalButton",
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.onNext();
      }
    }
  })], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }